export { default as Disclaimer } from './Disclaimer';
export { DisclaimerType } from './Disclaimer';
export type { DisclaimerProps } from './Disclaimer';
